import { required } from "@corporate-tailwind/corp-form";
import { SelectCode } from "@corporate-tailwind/model";
import { CountryDto } from "./country.model";

export class AddressDto {
    id: number | null = null; 
    streetNumber: string | null = null; 
    streetType: SelectCode | null = null; 
    streetName: string | null = null; 
    postalCode: string | null = null; 
    city: string | null = null; 
    state: string | null = null; 
    country: CountryDto | null = null; 
}

export class AddressSchema extends AddressDto {
    static schema = {
        id: { type: Number, builderOption: required },
        streetNumber: { type: String, builderOption: required } ,
        streetType: {type:SelectCode, builderOption: required } ,
        streetName: {type:String, builderOption: required } ,
        postalCode: {type:String, builderOption: required } ,
        city: {type:String, builderOption: required } ,
        state: {type:String, builderOption: required } ,
        country: {type: CountryDto, builderOption: required } 
    };

}